import React from 'react';
import PropTypes from 'prop-types';
import BEMHelper from '@ynap/bem-helper';

const bem = new BEMHelper('ScrollToTop');

const ScrollToTop = (props) => (
    <div className={bem(null, null, props.className)}>
        <div
            className={bem('iconContainer')}
            onClick={() => {
                props.trackBackToTopEvent && props.trackBackToTopEvent();
                jumpTo(props.scrollBehaviour);
            }}
        />
    </div>
);

const jumpTo = (scrollBehaviour) => {
    window.scroll({
        top: 0,
        behavior: scrollBehaviour,
    });
};

const propTypes = {
    className: PropTypes.string,
    scrollBehaviour: PropTypes.string,
    trackBackToTopEvent: PropTypes.func,
};

ScrollToTop.propTypes = propTypes;

export default ScrollToTop;
